"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const helpers_1 = require("./helpers");
const EntitiesActions_1 = require("../../actions/EntitiesActions");
const Requests_1 = require("../../../backend/models/Requests");
class CommentFormImpl extends React.Component {
    constructor(props) {
        super(props);
        this.innerState = new ContactFormInnerState();
        this.state = {
            email: '',
            message: '',
            name: '',
        };
        this.commentChange = this.commentChange.bind(this);
        this.nameChange = this.nameChange.bind(this);
        this.emailChange = this.emailChange.bind(this);
        this.onEnquirySubmit = this.onEnquirySubmit.bind(this);
    }
    isValid() {
        return this.innerState.email.isValid
            && this.innerState.name.isValid
            && this.innerState.message.isValid;
    }
    commentChange(event) {
        this.innerState.message.setValue(event.target.value);
        this.setState({ message: event.target.value });
    }
    nameChange(event) {
        this.innerState.name.setValue(event.target.value);
        this.setState({ name: event.target.value });
    }
    emailChange(event) {
        this.innerState.email.setValue(event.target.value);
        this.setState({ email: event.target.value });
    }
    onEnquirySubmit(event) {
        event.preventDefault();
        if (!this.isValid()) {
            return;
        }
        this.props.executeAction(EntitiesActions_1.default.sendEnquiry, new Requests_1.EnquiryRequest(this.innerState.message.getValue(), this.innerState.name.getValue(), this.innerState.email.getValue()));
        this.innerState.name.setValue('');
        this.innerState.message.setValue('');
        this.innerState.email.setValue('');
        this.setState({
            message: '',
            name: '',
            email: ''
        });
    }
}
exports.default = CommentFormImpl;
class ContactFormState {
}
class ContactFormInnerState {
    constructor() {
        this.message = new helpers_1.RequiredStringValue();
        this.name = new helpers_1.RequiredStringValue();
        this.email = new helpers_1.RequiredStringValue();
    }
}
